import { createFileRoute, Outlet } from '@tanstack/react-router'
import PlanMenu from '../../../../../containers/plan-menu'
import { plansContextSearchSchema } from './search-schemas'

// The plan list is the BACKDROP for this whole layout group: every child route
// here (rename, newfolder, import, move, exportPlan, …) is a modal that must
// render ON TOP of it. Keeping `<PlanMenu />` in `index.tsx` instead made
// each of those routes replace the list rather than layer over it.
// Mirrors `_projects/route.tsx`, which does the same for the project list.
function PlansLayout() {
  return (
    <>
      <PlanMenu />
      <Outlet />
    </>
  )
}

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans'
)({
  validateSearch: plansContextSearchSchema,
  component: PlansLayout
})
